import { render, staticRenderFns } from "./trainings.vue?vue&type=template&id=200d486c"
import script from "./trainings.vue?vue&type=script&lang=js"
export * from "./trainings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports